import { css } from 'styled-components';
import { fromTheme } from '../../utils';
// Props that should not be forwarded to the HTML DOM elements
export var shouldForwardProp = function shouldForwardProp(prop, defaultValidationFn) {
  return !['color', 'opacity', 'bg', 'backgroundColor', 'fontWeight'].includes(prop) && defaultValidationFn(prop);
};
export var makeEllipsis = function makeEllipsis(_ref) {
  var ellipsis = _ref.ellipsis;

  if (!ellipsis) {
    return null;
  }

  var maxWidth = typeof ellipsis === 'object' && ellipsis.maxWidth || '100%';
  var lineClamp = typeof ellipsis === 'object' && ellipsis.lines;
  return css(["", " overflow:hidden;text-overflow:ellipsis;max-width:", ";"], lineClamp ? "\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: " + lineClamp + ";\n      display: -webkit-box;\n    " : "\n      white-space: nowrap;\n    ", maxWidth);
};
export var makeTypographyVariant = function makeTypographyVariant(_ref2) {
  var variant = _ref2.variant;
  return css(["", ""], fromTheme("typography.variants." + variant));
};